/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

/**
 * @url https://www.npmjs.com/package/react-gtm-module
 */
import TagManager from 'react-gtm-module';

import { envIs } from '@fai/friendli-suite/shared/environments/conditionals';

/**
 * @url https://support.google.com/tagmanager/answer/6103696
 * @note GTM_ID is not secret
 */
const GTM_ID = 'GTM-MVXVF29V';

const tagManagerArgs = {
  gtmId: GTM_ID,
};

export default function InitGTM() {
  if (envIs.PRODUCTION) {
    return TagManager.initialize(tagManagerArgs);
  }
}
